import { render, staticRenderFns } from "./MediaPhoto.vue?vue&type=template&id=18dbf471&"
import script from "./MediaPhoto.vue?vue&type=script&lang=js&"
export * from "./MediaPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports